if (!window.KLWrapSelector) {
  window.KLWrapSelector = {
    boot: function () {
      document.querySelectorAll('[data-kl-wrap-selector]').forEach(function (root) {
        window.KLWrapSelector.init(root);
      });
    },

    init: function (root) {
      if (!root || root.dataset.klWrapReady === 'true') return;
      root.dataset.klWrapReady = 'true';

      var preview = root.querySelector('[data-kl-wrap-preview]');
      var closeBtn = root.querySelector('[data-kl-wrap-close]');
      if (!preview || !closeBtn) return;

      var previewImg = preview.querySelector('img');
      var previewLabel = preview.querySelector('[data-kl-wrap-label]');
      var pinnedOption = null;
      var hoverOption = null;
      var hideTimer = null;

      previewImg.addEventListener('load', function () {
        if (preview.hidden) return;
        var anchor = hoverOption || pinnedOption;
        if (anchor) positionPreview(anchor);
      });

      if (preview.parentNode !== document.body) {
        document.body.appendChild(preview);
      }

      function canHover() {
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      }

      function optionInput(option) {
        return option.querySelector('input');
      }

      function setSelected(option) {
        var group = option.getAttribute('data-group');
        root.querySelectorAll('[data-kl-wrap-option]').forEach(function (el) {
          if (el.getAttribute('data-group') === group) {
            el.classList.remove('is-selected');
          }
        });
        option.classList.add('is-selected');
        var input = optionInput(option);
        if (input) input.checked = true;
        var groupEl = option.closest('.kl-wrap__group');
        var selectedLabel = groupEl && groupEl.querySelector('[data-kl-wrap-selected]');
        if (selectedLabel) selectedLabel.textContent = option.getAttribute('data-label') || '';
      }

      function hidePreview() {
        preview.hidden = true;
        closeBtn.hidden = true;
        pinnedOption = null;
        hoverOption = null;
        root.classList.remove('is-preview-open');
      }

      function positionPreview(option) {
        preview.hidden = false;
        preview.style.visibility = 'hidden';
        previewImg.style.maxHeight = '';

        var rect = option.getBoundingClientRect();
        var card = root.getBoundingClientRect();
        var gap = 12;
        var width = preview.offsetWidth;
        var height = preview.offsetHeight;
        var top = card.top - height - gap;
        var left = rect.left + (rect.width / 2) - (width / 2);

        if (top < 8) {
          var spaceLeft = card.left - gap;
          var spaceRight = window.innerWidth - card.right - gap;
          if (spaceLeft >= 220 || (spaceLeft >= 160 && spaceLeft >= spaceRight)) {
            left = card.left - width - gap;
            top = Math.max(8, Math.min(rect.top - 8, window.innerHeight - height - 8));
          } else if (spaceRight >= 220) {
            left = card.right + gap;
            top = Math.max(8, Math.min(rect.top - 8, window.innerHeight - height - 8));
          } else if (window.innerHeight - card.bottom > height + gap) {
            top = card.bottom + gap;
            left = Math.max(8, (window.innerWidth - width) / 2);
          } else {
            var available = Math.max(180, card.top - 20);
            previewImg.style.maxHeight = available + 'px';
            height = preview.offsetHeight;
            top = Math.max(8, card.top - height - gap);
          }
        }

        left = Math.max(8, Math.min(left, window.innerWidth - width - 8));
        if (top + height > window.innerHeight - 8) {
          top = Math.max(8, window.innerHeight - height - 8);
        }
        preview.style.top = top + 'px';
        preview.style.left = left + 'px';
        preview.style.visibility = '';
      }

      function showPreview(option, pin) {
        var src = option.getAttribute('data-large-src');
        if (!src) {
          if (!pin) return;
          hidePreview();
          return;
        }
        window.clearTimeout(hideTimer);
        var label = option.getAttribute('data-label') || '';
        previewImg.alt = label;
        if (previewLabel) previewLabel.textContent = label;
        if (previewImg.getAttribute('src') !== src) {
          previewImg.src = src;
        }
        closeBtn.hidden = false;
        root.classList.add('is-preview-open');
        positionPreview(option);
        if (pin) {
          pinnedOption = option;
          hoverOption = null;
        } else {
          hoverOption = option;
        }
      }

      function scheduleHide() {
        window.clearTimeout(hideTimer);
        hideTimer = window.setTimeout(function () {
          if (pinnedOption) {
            showPreview(pinnedOption, true);
          } else {
            hidePreview();
          }
        }, 140);
      }

      root.querySelectorAll('[data-kl-wrap-option]').forEach(function (option) {
        var input = optionInput(option);
        if (input && input.checked) setSelected(option);

        option.addEventListener('mouseenter', function () {
          if (!canHover()) return;
          window.clearTimeout(hideTimer);
          showPreview(option, false);
        });

        option.addEventListener('mouseleave', function () {
          if (!canHover()) return;
          scheduleHide();
        });

        option.addEventListener('focusin', function () {
          showPreview(option, false);
        });

        option.addEventListener('click', function () {
          setSelected(option);
          showPreview(option, true);
        });

        if (input) {
          input.addEventListener('change', function () {
            if (!input.checked) return;
            setSelected(option);
          });
        }
      });

      var seenGroups = {};
      root.querySelectorAll('[data-kl-wrap-option]').forEach(function (option) {
        var group = option.getAttribute('data-group');
        if (seenGroups[group]) return;
        var groupOptions = root.querySelectorAll('[data-kl-wrap-option][data-group="' + group + '"]');
        var hasChecked = false;
        groupOptions.forEach(function (el) {
          var input = optionInput(el);
          if (input && input.checked) hasChecked = true;
        });
        if (!hasChecked && groupOptions[0]) {
          setSelected(groupOptions[0]);
        }
        seenGroups[group] = true;
      });

      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        hidePreview();
      });

      document.addEventListener('click', function (event) {
        if (preview.hidden) return;
        if (root.contains(event.target) || preview.contains(event.target)) return;
        hidePreview();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !preview.hidden) hidePreview();
      });

      window.addEventListener('scroll', function () {
        if (preview.hidden) return;
        var anchor = hoverOption || pinnedOption;
        if (anchor) positionPreview(anchor);
      }, true);

      window.addEventListener('resize', function () {
        if (preview.hidden) return;
        var anchor = hoverOption || pinnedOption;
        if (anchor) positionPreview(anchor);
      });
    }
  };

  document.addEventListener('shopify:section:load', function () {
    window.KLWrapSelector.boot();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    document.querySelectorAll('[data-kl-wrap-preview][data-section-id="' + sectionId + '"]').forEach(function (node) {
      node.remove();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.KLWrapSelector.boot);
  } else {
    window.KLWrapSelector.boot();
  }
}
